/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import { Box, Container } from '@material-ui/core';
import PageContainer from 'components/PageContainer';
import styles from './styles';
import CancelButton from 'features/CancelButton';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import Button from 'components/Button';
import { contentContainer } from 'features/Theme';

interface PropTypes {
  restartPath: string;
}

const ExpiredView: React.FC<PropTypes> = ({ restartPath }) => {
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  return (
    <Box css={contentContainer}>
      <PageContainer>
        <h1 css={styles.headerTitle}>{tMd('prequal.expired.title')}</h1>

        <Container maxWidth="sm">
          <Box my={3}>
            <p css={styles.body}>{tMd('prequal.expired.message')}</p>
          </Box>
          <ActionButtonContainer>
            <Button
              id="continueToApplication"
              variant="contained"
              href={restartPath}
            >
              {t('prequal.expired.continueButton')}
            </Button>

            <CancelButton />
          </ActionButtonContainer>
        </Container>
      </PageContainer>
    </Box>
  );
};

export default ExpiredView;
